export default "__VITE_ASSET__DagTf$Zk__"